import { render, staticRenderFns } from "./CardStack.vue?vue&type=template&id=c0d68d76&"
import script from "./CardStack.vue?vue&type=script&lang=js&"
export * from "./CardStack.vue?vue&type=script&lang=js&"
import style0 from "./CardStack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports